__turbopack_context__.v({
  "className": "caveat_ec8d01a5-module__25IhqW__className",
});
